<div class="photo_gallery_item"
    [class.small]="this.sizePhoto === 'small'" 
    [class.medium]="this.sizePhoto === 'medium'" 
    [class.big]="this.sizePhoto === 'big'" 
    (click)="this.selectPhoto()"
    >    
    <div class="photo_gallery_item_content">
        @if(this.displayStore){
            <div class="photo_store">
                <app-retailer-logo [retailer]="this.getRetailerLogo()" size="small"/>
                <div class="photo_store_name">{{photo.store.name}}</div>
            </div>
        }
        <div class="photo_img">
            <marv-img [src]="photo.urlThumbnail" objectFit="cover"/>
        </div>
        <div class="photo_footer">
            <div class="photo_date">{{this.photo.day | epochToString: 'dddd DD/MM/YYYY'}}</div>
            @if(this.displayOperation){
                <div class="photo_operation">
                    <marv-tag [color]="this.missionTypeService.getColor(this.photo.operation.typeOfMission)" size="small">{{this.photo.operation.name}}</marv-tag>
                </div>
            }
            @if(this.photo.modelName !== ''){
                <div class="photo_model">{{this.photo.modelName}}</div>
            }
            @if(this.photo.tagName !== ''){
                <div class="photo_tag">{{this.photo.tagName}}</div>
            }
        </div>
    </div>
</div>